import { context, type Span, trace } from '@opentelemetry/api';
import { apiGet } from '@/api/apiClient';
import type { BannerApi, BannerUnified } from '@/api/banners/types';
import { getBannerCode } from '@/api/utils/helpers/getBannerCode';
import { unifyBanner } from '@/api/utils/unifiers/unifyBanner';
import { instrumentAsync } from '@/otel';
import type { Language } from '@/utilities/language';

export async function getBanner(
  language: Language,
  position: string,
): Promise<BannerUnified | null> {
  return await instrumentAsync('api.banners.getBanner', async (span: Span) => {
    const code = getBannerCode(language);

    const res = await apiGet<BannerApi>(
      `/banner/${code}/${position}/`,
      trace.setSpan(context.active(), span),
    );

    if (Array.isArray(res.data)) {
      return null;
    }

    return unifyBanner(res.data);
  });
}
